<template>
  <view-wrap>
    <div class="toolbox">
      <div class="settings" :class="{ chosen: viewChosen }">
        <div class="leagues">
          <h3 class="nav-panel-header">
            <span v-if="viewChosen">League:</span>
            <span v-else>Select a League:</span>
          </h3>
          <form @submit.prevent>
            <select v-model="selectedLeague" @change="setPrefs()">
              <option :value="{ yahoo_object: {} }" default selected disabled>
                Select League:
              </option>
              <option
                :value="league"
                v-for="(league, i) in leagueData"
                v-bind:key="i"
              >
                {{
                  league.yahoo_object.season + " - " + league.yahoo_object.name
                }}
              </option>
            </select>
          </form>
        </div>
      </div>
      <!-- <div v-if="!selectedLeagueFinished && canRefresh">
        <p>
          <span class="description">Last data update: {{leagueLastUpdate}}</span>
          <button @click="forceRefresh()">Refresh data</button>
        </p>
      </div> -->
      <div v-show="viewChosen">
        <div class="tabs">
          <router-link class="tab" :to="{ name: 'weeks' }"
            >Weekly Performance</router-link
          >
          <router-link class="tab" :to="{ name: 'category' }"
            >Category Strengths</router-link
          >
          <router-link class="tab" :to="{ name: 'compare-teams' }"
            >Compare Teams</router-link
          >
          <!-- <router-link
            class="tab"
            v-if="selectedLeague && +selectedLeague.yahoo_object.season >= 2020"
            :to="{ name: 'compare-rosters' }"
            >Roster Strength</router-link
          > -->
          <!-- <router-link class="tab" :to="{name: 'matchup'}">Matchup</router-link> -->
        </div>
        <div class="content bg-light">
          <router-view
            :leagues="leagues"
            :selectedLeague="selectedLeague"
            :loaded="loaded"
            :refreshLeague="refreshLeague"
            :leagueName="leagueName"
          ></router-view>
        </div>
      </div>
    </div>
  </view-wrap>
</template>

<script>
import Cookies from "js-cookie";
import firebase from "firebase/app";
import 'firebase/firebase-remote-config';

export default {
  name: "toolbox",
  buyMeCoffeeScript: null,
  data() {
    return {
      selectedLeague: {
        yahoo_object: {},
      },
      leagueData: [],
      // leagueData: [{"start_week":3,"is_finished":false,"num_teams":4,"season":2019,"url":"https://basketball.fantasysports.yahoo.com/nba/215903","yahoo_object":{"league_type":"private","scoring_type":"head","name":"h2h-standard","start_week":"3","allow_add_to_dl_extra_pos":1,"draft_status":"postdraft","season":"2019","current_week":5,"is_cash_league":"0","edit_key":"2019-11-25","is_pro_league":"0","game_code":"nba","weekly_deadline":"","iris_group_chat_id":"","league_id":"215903","num_teams":4,"logo_url":false,"url":"https://basketball.fantasysports.yahoo.com/nba/215903","start_date":"2019-11-04","renew":"","end_date":"2020-04-15","end_week":"24","league_update_timestamp":"1574577726","renewed":"","short_invitation_url":"https://basketball.fantasysports.yahoo.com/nba/215903/invitation?key=c6bd8eed87867d2e&ikey=5b033d196f19be6c","league_key":"395.l.215903"},"current_week":5,"scoring_type":"head","end_week":24,"game_code":"nba"},{"current_week":5,"scoring_type":"headpoint","end_week":24,"game_code":"nba","start_week":3,"is_finished":false,"num_teams":4,"season":2019,"url":"https://basketball.fantasysports.yahoo.com/nba/215904","yahoo_object":{"start_week":"3","allow_add_to_dl_extra_pos":1,"draft_status":"postdraft","season":"2019","current_week":5,"is_cash_league":"0","edit_key":"2019-11-25","is_pro_league":"0","game_code":"nba","weekly_deadline":"1","iris_group_chat_id":"","league_id":"215904","num_teams":4,"logo_url":false,"url":"https://basketball.fantasysports.yahoo.com/nba/215904","start_date":"2019-11-04","renew":"","end_date":"2020-04-15","end_week":"24","league_update_timestamp":"1574577726","renewed":"","short_invitation_url":"https://basketball.fantasysports.yahoo.com/nba/215904/invitation?key=6404690503abca55&ikey=814765c410f2537d","league_key":"395.l.215904","league_type":"private","scoring_type":"headpoint","name":"Common Spheres H2HWP"}},{"current_week":5,"scoring_type":"headpoint","end_week":24,"game_code":"nba","start_week":3,"is_finished":false,"num_teams":4,"season":2019,"url":"https://basketball.fantasysports.yahoo.com/nba/215927","yahoo_object":{"league_id":"215927","num_teams":4,"logo_url":false,"url":"https://basketball.fantasysports.yahoo.com/nba/215927","start_date":"2019-11-04","renew":"","end_date":"2020-04-15","end_week":"24","league_update_timestamp":"1574577732","renewed":"","league_key":"395.l.215927","league_type":"private","scoring_type":"headpoint","name":"Common Spheres H2H Points","start_week":"3","allow_add_to_dl_extra_pos":1,"draft_status":"postdraft","season":"2019","current_week":5,"is_cash_league":"0","edit_key":"2019-11-25","is_pro_league":"0","game_code":"nba","weekly_deadline":"1","iris_group_chat_id":""}}],
      loaded: false,
      // loaded: true
      refreshLeague: false,
    };
  },
  mounted() {
    const bmc_attributes = [
      { name: "src", value: "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js"},
      { name: "data-name", value: "BMC-Widget"},
      { name: "data-cfasync", value: "false"},
      { name: "data-id", value: "fantasyfalcon"},
      { name: "data-description", value: "Support me on Buy me a coffee!"},
      { name: "data-message", value: "Help support FF by buying me a coffee! All the earnings go towards infrastructure costs or actual coffee."},
      { name: "data-color", value: "#5F7FFF"},
      { name: "data-position", value: "Right"},
      { name: "data-x_margin", value: "18"},
      { name: "data-y_margin", value: "18"}
    ];

    this.buyMeCoffeeScript = document.createElement("script");
    this.buyMeCoffeeScript.async = true;
    for (const attr of bmc_attributes) {
      this.buyMeCoffeeScript.setAttribute(attr.name, attr.value)
    }
 
    //Call window on load to show the image
    this.buyMeCoffeeScript.onload = function () {
      var evt = document.createEvent("Event");
      evt.initEvent("DOMContentLoaded", false, false);
      window.dispatchEvent(evt);
    };
  },
  created: async function () {
    // js-cookie v3 dropped getJSON; parse stored prefs manually to avoid runtime errors in prod
    let prefs = null;
    const prefsString = Cookies.get("prefs");
    if (prefsString) {
      try {
        prefs = JSON.parse(prefsString);
      } catch (err) {
        console.warn("Could not parse prefs cookie", err);
      }
    }
    try {
      this.$store.dispatch("isLoading", true);
      this.leagueData = await this.$store.state.apiService.getLeagues();
      //autoselect first league if there's only 1 league
      if (this.leagueData.length == 1) {
        this.selectedLeague = this.leagueData[0];
      }
      this.loaded = true;
      if (prefs) this.applyPrefs(prefs);
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 403) {
        this.$store.dispatch("login", true);
      }
    } finally {
      this.$store.dispatch("isLoading", false);
    }

    const remoteConfig = firebase.remoteConfig()
    remoteConfig.settings.minimumFetchIntervalMillis = window.location.origin.startsWith("http://localhost:") ? 5000 : 600000; // 10mins for prod
    const buyMeCoffeeScript = this.buyMeCoffeeScript
    const analyticsService = this.$store.state.analyticsService
    remoteConfig.fetchAndActivate().then(() => {
      const shouldBuyMeCoffee = remoteConfig.getValue("buy_me_coffee").asBoolean();
      if(shouldBuyMeCoffee) {
        setTimeout(() => {
          document.body.appendChild(buyMeCoffeeScript);
          remoteConfig.activate();
          if(!window.location.origin.startsWith("http://localhost:")) {
            analyticsService.logEvent("buymecoffee_activated")
          }
        }, 1000);
      }
    }).catch((err) => {
      console.error(err);
    });
    
  },
  components: {},

  computed: {
    viewChosen: function () {
      return this.leagueName;
    },
    leagueName: function () {
      return this.selectedLeague.yahoo_object.name || "";
    },
    selectedLeagueFinished: function () {
      return this.selectedLeague.yahoo_object.is_finished == 1 ? true : false;
    },
    leagueLastUpdate: function () {
      const lastUpdate = new Date(
        this.selectedLeague.yahoo_object.league_update_timestamp * 1000 || 0
      );
      //We can do something fancier, show, 2 hours ago or 1 day ago etc..
      return lastUpdate;
    },
    canRefresh: function () {
      const lastUpdate = new Date(
        this.selectedLeague.yahoo_object.league_update_timestamp * 1000 || 0
      );
      const diffMins = Math.round((new Date() - lastUpdate) / 1000 / 60);
      if (diffMins > 60) {
        return true;
      } else {
        return false;
      }
    },
    leagues: function () {
      if (!this.leagueData) return [];
      let leagues = [];
      for (let index in this.leagueData) {
        leagues.push({
          name: this.leagueData[index].yahoo_object.name,
          key: this.leagueData[index].yahoo_object.league_key,
        });
      }

      return leagues;
    },
  },
  methods: {
    setPrefs: function () {
      this.$nextTick(() => {
        Cookies.set(
          "prefs",
          { selectedLeagueKey: this.selectedLeague.league_key },
          { sameSite: "strict" }
        );
      });
    },
    applyPrefs: function (prefs) {
      if (prefs.selectedLeagueKey) {
        console.log("applying selected league", prefs.selectedLeagueKey);
        this.selectedLeague = this.leagueData.find(
          (l) => l.league_key == prefs.selectedLeagueKey
        );
        console.log("Selected league is: ", this.selectedLeague);
      }
    },
    forceRefresh: function () {
      console.log("force refresh clicked");
      // //need to refresh league data
      // //need to refresh getWeeks, the rest uses that
      // this.refreshLeague = true;
    },
  },
};
</script>

<style src="./toolbox.styl" lang="stylus" scoped></style>
